const CountriesList = [
  { value: 'IN', region: 'global/en', reg: 'global', name: 'India' },
  { value: 'US', region: 'us/en', reg: 'us', name: 'United States' },
  { value: 'AF', region: 'us/en', reg: 'us', name: 'Afghanistan' },
  { value: 'AL', region: 'uk/en', reg: 'uk', name: 'Albania' },
  { value: 'DZ', region: 'us/en', reg: 'us', name: 'Algeria' },
  { value: 'AS', region: 'sg/en', reg: 'sg', name: 'American Samoa' },
  { value: 'AD', region: 'us/en', reg: 'us', name: 'Andorra' },
  { value: 'AO', region: 'us/en', reg: 'us', name: 'Angola' },
  { value: 'AI', region: 'us/en', reg: 'us', name: 'Anguilla' },
  { value: 'AQ', region: 'us/en', reg: 'us', name: 'Antarctica' },
  { value: 'AG', region: 'us/en', reg: 'us', name: 'Antigua and Barbuda' },
  { value: 'AR', region: 'us/en', reg: 'us', name: 'Argentina' },
  { value: 'AM', region: 'us/en', reg: 'us', name: 'Armenia' },
  { value: 'AW', region: 'us/en', reg: 'us', name: 'Aruba' },
  { value: 'AU', region: 'au/en', reg: 'au', name: 'Australia' },
  { value: 'AT', region: 'uk/en', reg: 'uk', name: 'Austria' },
  { value: 'AZ', region: 'us/en', reg: 'us', name: 'Azerbaijan' },
  { value: 'BS', region: 'us/en', reg: 'us', name: 'Bahamas' },
  { value: 'BH', region: 'us/en', reg: 'us', name: 'Bahrain' },
  { value: 'BD', region: 'sg/en', reg: 'sg', name: 'Bangladesh' },
  { value: 'BB', region: 'us/en', reg: 'us', name: 'Barbados' },
  { value: 'BY', region: 'us/en', reg: 'us', name: 'Belarus' },
  { value: 'BE', region: 'uk/en', reg: 'uk', name: 'Belgium' },
  { value: 'BZ', region: 'us/en', reg: 'us', name: 'Belize' },
  { value: 'BJ', region: 'us/en', reg: 'us', name: 'Benin' },
  { value: 'BM', region: 'us/en', reg: 'us', name: 'Bermuda' },
  { value: 'BT', region: 'sg/en', reg: 'sg', name: 'Bhutan' },
  { value: 'BO', region: 'us/en', reg: 'us', name: 'Bolivia' },
  { value: 'BA', region: 'uk/en', reg: 'uk', name: 'Bosnia and Herzegovina' },
  { value: 'BW', region: 'us/en', reg: 'us', name: 'Botswana' },
  { value: 'BV', region: 'us/en', reg: 'us', name: 'Bouvet Island' },
  { value: 'BR', region: 'us/en', reg: 'us', name: 'Brazil' },
  {
    value: 'IO',
    region: 'us/en',
    reg: 'us',
    name: 'British Indian Ocean Territory',
  },
  { value: 'VG', region: 'us/en', reg: 'us', name: 'British Virgin Islands' },
  { value: 'BN', region: 'sg/en', reg: 'sg', name: 'Brunei' },
  { value: 'BG', region: 'uk/en', reg: 'uk', name: 'Bulgaria' },
  { value: 'BF', region: 'us/en', reg: 'us', name: 'Burkina Faso' },
  { value: 'BI', region: 'us/en', reg: 'us', name: 'Burundi' },
  { value: 'KH', region: 'sg/en', reg: 'sg', name: 'Cambodia' },
  { value: 'CM', region: 'us/en', reg: 'us', name: 'Cameroon' },
  { value: 'CA', region: 'us/en', reg: 'us', name: 'Canada' },
  { value: 'CV', region: 'us/en', reg: 'us', name: 'Cabo Verde' },
  { value: 'KY', region: 'us/en', reg: 'us', name: 'Cayman Islands' },
  {
    value: 'CF',
    region: 'us/en',
    reg: 'us',
    name: 'Central African Republic',
  },
  { value: 'TD', region: 'us/en', reg: 'us', name: 'Chad' },
  { value: 'CL', region: 'us/en', reg: 'us', name: 'Chile' },
  { value: 'CN', region: 'sg/en', reg: 'sg', name: 'China' },
  { value: 'CX', region: 'sg/en', reg: 'sg', name: 'Christmas Island' },
  { value: 'CP', region: 'us/en', reg: 'us', name: 'Clipperton Island' },
  { value: 'CC', region: 'sg/en', reg: 'sg', name: 'Cocos [Keeling] Islands' },
  { value: 'CO', region: 'us/en', reg: 'us', name: 'Colombia' },
  { value: 'KM', region: 'us/en', reg: 'us', name: 'Comoros' },
  {
    value: 'CG',
    region: 'us/en',
    reg: 'us',
    name: 'Congo - Brazzaville',
  },
  { value: 'CD', region: 'us/en', reg: 'us', name: 'Congo - Kinshasa' },
  { value: 'CK', region: 'sg/en', reg: 'sg', name: 'Cook Islands' },
  { value: 'CR', region: 'us/en', reg: 'us', name: 'Costa Rica' },
  { value: 'HR', region: 'uk/en', reg: 'uk', name: 'Croatia' },
  { value: 'CU', region: 'us/en', reg: 'us', name: 'Cuba' },
  { value: 'CY', region: 'uk/en', reg: 'uk', name: 'Cyprus' },
  { value: 'CZ', region: 'uk/en', reg: 'uk', name: 'Czech Republic' },
  { value: 'CI', region: 'us/en', reg: 'us', name: 'Côte d’Ivoire' },
  { value: 'DK', region: 'uk/en', reg: 'uk', name: 'Denmark' },
  { value: 'DJ', region: 'us/en', reg: 'us', name: 'Djibouti' },
  { value: 'DM', region: 'us/en', reg: 'us', name: 'Dominica' },
  { value: 'DO', region: 'us/en', reg: 'us', name: 'Dominican Republic' },
  { value: 'EC', region: 'us/en', reg: 'us', name: 'Ecuador' },
  { value: 'EG', region: 'us/en', reg: 'us', name: 'Egypt' },
  { value: 'SV', region: 'us/en', reg: 'us', name: 'El Salvador' },
  {
    value: 'GQ',
    region: 'us/en',
    reg: 'us',
    name: 'Equatorial Guinea',
  },
  { value: 'ER', region: 'us/en', reg: 'us', name: 'Eritrea' },
  { value: 'EE', region: 'uk/en', reg: 'uk', name: 'Estonia' },
  { value: 'ET', region: 'us/en', reg: 'us', name: 'Ethiopia' },
  { value: 'FK', region: 'us/en', reg: 'us', name: 'Falkland Islands' },
  { value: 'FO', region: 'us/en', reg: 'us', name: 'Faroe Islands' },
  { value: 'FJ', region: 'sg/en', reg: 'sg', name: 'Fiji' },
  { value: 'FI', region: 'uk/en', reg: 'uk', name: 'Finland' },
  { value: 'FR', region: 'uk/en', reg: 'uk', name: 'France' },
  { value: 'GF', region: 'us/en', reg: 'us', name: 'French Guiana' },
  { value: 'PF', region: 'sg/en', reg: 'sg', name: 'French Polynesia' },
  {
    value: 'TF',
    region: 'us/en',
    reg: 'us',
    name: 'French Southern Territories',
  },
  { value: 'GA', region: 'us/en', reg: 'us', name: 'Gabon' },
  { value: 'GM', region: 'us/en', reg: 'us', name: 'Gambia' },
  { value: 'GE', region: 'us/en', reg: 'us', name: 'Georgia' },
  { value: 'DE', region: 'uk/en', reg: 'uk', name: 'Germany' },
  { value: 'GH', region: 'us/en', reg: 'us', name: 'Ghana' },
  { value: 'GI', region: 'us/en', reg: 'us', name: 'Gibraltar' },
  { value: 'GR', region: 'uk/en', reg: 'uk', name: 'Greece' },
  { value: 'GG', region: 'us/en', reg: 'us', name: 'Guernsey' },
  { value: 'GL', region: 'us/en', reg: 'us', name: 'Greenland' },
  { value: 'GD', region: 'us/en', reg: 'us', name: 'Grenada' },
  { value: 'GP', region: 'us/en', reg: 'us', name: 'Guadeloupe' },
  { value: 'GU', region: 'sg/en', reg: 'sg', name: 'Guam' },
  { value: 'GT', region: 'us/en', reg: 'us', name: 'Guatemala' },
  { value: 'GN', region: 'us/en', reg: 'us', name: 'Guinea' },
  { value: 'GW', region: 'us/en', reg: 'us', name: 'Guinea-Bissau' },
  { value: 'GY', region: 'us/en', reg: 'us', name: 'Guyana' },
  { value: 'HT', region: 'us/en', reg: 'us', name: 'Haiti' },
  {
    value: 'HM',
    region: 'sg/en',
    reg: 'sg',
    name: 'Heard Island and McDonald Islands',
  },
  { value: 'HN', region: 'us/en', reg: 'us', name: 'Honduras' },
  { value: 'HK', region: 'au/en', reg: 'au', name: 'Hong Kong SAR China' },
  { value: 'HU', region: 'uk/en', reg: 'uk', name: 'Hungary' },
  { value: 'IS', region: 'uk/en', reg: 'uk', name: 'Iceland' },
  { value: 'ID', region: 'sg/en', reg: 'sg', name: 'Indonesia' },
  { value: 'IR', region: 'us/en', reg: 'us', name: 'Iran' },
  { value: 'IQ', region: 'us/en', reg: 'us', name: 'Iraq' },
  { value: 'IE', region: 'uk/en', reg: 'uk', name: 'Ireland' },
  { value: 'IL', region: 'uk/en', reg: 'uk', name: 'Israel' },
  { value: 'IT', region: 'uk/en', reg: 'uk', name: 'Italy' },
  { value: 'JM', region: 'us/en', reg: 'us', name: 'Jamaica' },
  { value: 'JP', region: 'sg/en', reg: 'sg', name: 'Japan' },
  { value: 'JO', region: 'us/en', reg: 'us', name: 'Jordan' },
  { value: 'KZ', region: 'us/en', reg: 'us', name: 'Kazakhstan' },
  { value: 'KE', region: 'us/en', reg: 'us', name: 'Kenya' },
  { value: 'KI', region: 'sg/en', reg: 'sg', name: 'Kiribati' },
  { value: 'XK', region: 'uk/en', reg: 'uk', name: 'Kosovo' },
  { value: 'KW', region: 'us/en', reg: 'us', name: 'Kuwait' },
  { value: 'KG', region: 'us/en', reg: 'us', name: 'Kyrgyzstan' },
  { value: 'LA', region: 'sg/en', reg: 'sg', name: 'Laos' },
  { value: 'LV', region: 'uk/en', reg: 'uk', name: 'Latvia' },
  { value: 'LB', region: 'us/en', reg: 'us', name: 'Lebanon' },
  { value: 'LS', region: 'us/en', reg: 'us', name: 'Lesotho' },
  { value: 'LR', region: 'us/en', reg: 'us', name: 'Liberia' },
  { value: 'LY', region: 'us/en', reg: 'us', name: 'Libya' },
  { value: 'LI', region: 'uk/en', reg: 'uk', name: 'Liechtenstein' },
  { value: 'LT', region: 'uk/en', reg: 'uk', name: 'Lithuania' },
  { value: 'LU', region: 'uk/en', reg: 'uk', name: 'Luxembourg' },
  { value: 'MO', region: 'sg/en', reg: 'sg', name: 'Macau SAR China' },
  { value: 'MK', region: 'uk/en', reg: 'uk', name: 'Macedonia' },
  { value: 'MG', region: 'us/en', reg: 'us', name: 'Madagascar' },
  { value: 'MW', region: 'us/en', reg: 'us', name: 'Malawi' },
  { value: 'MY', region: 'my/en', reg: 'my', name: 'Malaysia' },
  { value: 'MV', region: 'us/en', reg: 'us', name: 'Maldives' },
  { value: 'ML', region: 'us/en', reg: 'us', name: 'Mali' },
  { value: 'MT', region: 'uk/en', reg: 'uk', name: 'Malta' },
  { value: 'MH', region: 'sg/en', reg: 'sg', name: 'Marshall Islands' },
  { value: 'MQ', region: 'us/en', reg: 'us', name: 'Martinique' },
  { value: 'MR', region: 'us/en', reg: 'us', name: 'Mauritania' },
  { value: 'MU', region: 'us/en', reg: 'us', name: 'Mauritius' },
  { value: 'YT', region: 'us/en', reg: 'us', name: 'Mayotte' },
  { value: 'MX', region: 'us/en', reg: 'us', name: 'Mexico' },
  { value: 'FM', region: 'sg/en', reg: 'sg', name: 'Micronesia' },
  { value: 'MD', region: 'us/en', reg: 'us', name: 'Moldova' },
  { value: 'MC', region: 'us/en', reg: 'us', name: 'Monaco' },
  { value: 'MN', region: 'sg/en', name: 'Mongolia' },
  { value: 'ME', region: 'uk/en', reg: 'uk', name: 'Montenegro' },
  { value: 'MS', region: 'us/en', reg: 'us', name: 'Montserrat' },
  { value: 'MA', region: 'us/en', reg: 'us', name: 'Morocco' },
  { value: 'MZ', region: 'us/en', reg: 'us', name: 'Mozambique' },
  { value: 'MM', region: 'sg/en', reg: 'sg', name: 'Myanmar [Burma]' },
  { value: 'NA', region: 'us/en', reg: 'us', name: 'Namibia' },
  { value: 'NR', region: 'sg/en', reg: 'sg', name: 'Nauru' },
  { value: 'NP', region: 'au/en', reg: 'au', name: 'Nepal' },
  { value: 'NL', region: 'uk/en', reg: 'uk', name: 'Netherlands' },
  { value: 'AN', region: 'us/en', reg: 'us', name: 'Netherlands Antilles' },
  { value: 'NC', region: 'sg/en', reg: 'sg', name: 'New Caledonia' },
  { value: 'NZ', region: 'au/en', reg: 'au', name: 'New Zealand' },
  { value: 'NI', region: 'us/en', reg: 'us', name: 'Nicaragua' },
  { value: 'NE', region: 'us/en', reg: 'us', name: 'Niger' },
  { value: 'NG', region: 'us/en', reg: 'us', name: 'Nigeria' },
  { value: 'NU', region: 'sg/en', reg: 'sg', name: 'Niue' },
  { value: 'NF', region: 'sg/en', reg: 'sg', name: 'Norfolk Island' },
  { value: 'MP', region: 'sg/en', reg: 'sg', name: 'Northern Mariana Islands' },
  { value: 'KP', region: 'sg/en', reg: 'sg', name: 'North Korea' },
  { value: 'NO', region: 'uk/en', reg: 'uk', name: 'Norway' },
  { value: 'OM', region: 'us/en', reg: 'us', name: 'Oman' },
  { value: 'PK', region: 'us/en', reg: 'us', name: 'Pakistan' },
  { value: 'PW', region: 'sg/en', reg: 'sg', name: 'Palau' },
  {
    value: 'PS',
    region: 'us/en',
    reg: 'us',
    name: 'Palestinian Territories',
  },
  { value: 'PA', region: 'us/en', reg: 'us', name: 'Panama' },
  { value: 'PG', region: 'sg/en', reg: 'sg', name: 'Papua New Guinea' },
  { value: 'PY', region: 'us/en', reg: 'us', name: 'Paraguay' },
  { value: 'PE', region: 'us/en', reg: 'us', name: 'Peru' },
  { value: 'PH', region: 'sg/en', reg: 'sg', name: 'Philippines' },
  { value: 'PN', region: 'sg/en', reg: 'sg', name: 'Pitcairn Islands' },
  { value: 'PL', region: 'uk/en', reg: 'uk', name: 'Poland' },
  { value: 'PT', region: 'uk/en', reg: 'uk', name: 'Portugal' },
  { value: 'PR', region: 'us/en', reg: 'us', name: 'Puerto Rico' },
  { value: 'QA', region: 'us/en', reg: 'us', name: 'Qatar' },
  { value: 'RO', region: 'uk/en', reg: 'uk', name: 'Romania' },
  { value: 'RU', region: 'us/en', reg: 'us', name: 'Russia' },
  { value: 'RW', region: 'us/en', reg: 'us', name: 'Rwanda' },
  { value: 'RE', region: 'us/en', reg: 'us', name: 'Réunion' },
  { value: 'SH', region: 'us/en', reg: 'us', name: 'Saint Helena' },
  { value: 'KN', region: 'us/en', reg: 'us', name: 'Saint Kitts and Nevis' },
  { value: 'LC', region: 'us/en', reg: 'us', name: 'Saint Lucia' },
  {
    value: 'PM',
    region: 'us/en',
    reg: 'us',
    name: 'Saint Pierre and Miquelon',
  },
  {
    value: 'VC',
    region: 'us/en',
    reg: 'us',
    name: 'Saint Vincent and the Grenadines',
  },
  { value: 'WS', region: 'sg/en', reg: 'sg', name: 'Samoa' },
  { value: 'SM', region: 'us/en', reg: 'us', name: 'San Marino' },
  { value: 'SA', region: 'us/en', reg: 'us', name: 'Saudi Arabia' },
  { value: 'SN', region: 'us/en', reg: 'us', name: 'Senegal' },
  { value: 'RS', region: 'uk/en', reg: 'uk', name: 'Serbia' },
  { value: 'SC', region: 'us/en', reg: 'us', name: 'Seychelles' },
  { value: 'SL', region: 'us/en', reg: 'us', name: 'Sierra Leone' },
  { value: 'SG', region: 'sg/en', reg: 'sg', name: 'Singapore' },
  { value: 'SK', region: 'uk/en', reg: 'uk', name: 'Slovakia' },
  { value: 'SI', region: 'uk/en', reg: 'uk', name: 'Slovenia' },
  { value: 'SB', region: 'sg/en', reg: 'sg', name: 'Solomon Islands' },
  { value: 'SO', region: 'us/en', reg: 'us', name: 'Somalia' },
  { value: 'ZA', region: 'us/en', reg: 'us', name: 'South Africa' },
  {
    value: 'GS',
    region: 'us/en',
    reg: 'us',
    name: 'South Georgia and the South Sandwich Islands',
  },
  { value: 'KR', region: 'sg/en', reg: 'sg', name: 'South Korea' },
  { value: 'ES', region: 'uk/en', reg: 'uk', name: 'Spain' },
  { value: 'LK', region: 'sg/en', reg: 'sg', name: 'Sri Lanka' },
  { value: 'SD', region: 'us/en', reg: 'us', name: 'Sudan' },
  { value: 'SR', region: 'us/en', reg: 'us', name: 'Suriname' },
  {
    value: 'SJ',
    region: 'us/en',
    reg: 'us',
    name: 'Svalbard and Jan Mayen',
  },
  { value: 'SZ', region: 'us/en', reg: 'us', name: 'Swaziland' },
  { value: 'SE', region: 'uk/en', reg: 'uk', name: 'Sweden' },
  { value: 'CH', region: 'uk/en', reg: 'uk', name: 'Switzerland' },
  { value: 'SY', region: 'us/en', reg: 'us', name: 'Syria' },
  {
    value: 'ST',
    region: 'us/en',
    reg: 'us',
    name: 'São Tomé and Príncipe',
  },
  { value: 'TW', region: 'sg/en', reg: 'sg', name: 'Taiwan' },
  { value: 'TJ', region: 'us/en', reg: 'us', name: 'Tajikistan' },
  { value: 'TZ', region: 'us/en', reg: 'us', name: 'Tanzania' },
  { value: 'TH', region: 'sg/en', reg: 'sg', name: 'Thailand' },
  { value: 'TL', region: 'sg/en', reg: 'sg', name: 'Timor-Leste' },
  { value: 'TG', region: 'us/en', reg: 'us', name: 'Togo' },
  { value: 'TK', region: 'sg/en', reg: 'sg', name: 'Tokelau' },
  { value: 'TO', region: 'sg/en', reg: 'sg', name: 'Tonga' },
  { value: 'TT', region: 'us/en', reg: 'us', name: 'Trinidad and Tobago' },
  { value: 'TN', region: 'us/en', reg: 'us', name: 'Tunisia' },
  { value: 'TR', region: 'uk/en', reg: 'uk', name: 'Turkey' },
  { value: 'TM', region: 'us/en', reg: 'us', name: 'Turkmenistan' },
  { value: 'TC', region: 'us/en', reg: 'us', name: 'Turks and Caicos Islands' },
  { value: 'TV', region: 'sg/en', reg: 'sg', name: 'Tuvalu' },
  { value: 'UM', region: 'sg/en', reg: 'sg', name: 'U.S. Outlying Islands' },
  { value: 'VI', region: 'us/en', reg: 'us', name: 'U.S. Virgin Islands' },
  { value: 'UG', region: 'us/en', reg: 'us', name: 'Uganda' },
  { value: 'UA', region: 'uk/en', reg: 'uk', name: 'Ukraine' },
  {
    value: 'AE',
    region: 'us/en',
    reg: 'us',
    name: 'United Arab Emirates',
  },
  { value: 'GB', region: 'uk/en', reg: 'uk', name: 'United Kingdom' },
  { value: 'UY', region: 'us/en', reg: 'us', name: 'Uruguay' },
  { value: 'UZ', region: 'us/en', reg: 'us', name: 'Uzbekistan' },
  { value: 'VU', region: 'sg/en', reg: 'sg', name: 'Vanuatu' },
  { value: 'VA', region: 'us/en', reg: 'us', name: 'Vatican City' },
  { value: 'VE', region: 'us/en', reg: 'us', name: 'Venezuela' },
  { value: 'VN', region: 'sg/en', reg: 'sg', name: 'Vietnam' },
  { value: 'WF', region: 'sg/en', reg: 'sg', name: 'Wallis and Futuna' },
  { value: 'EH', region: 'us/en', reg: 'us', name: 'Western Sahara' },
  { value: 'YE', region: 'us/en', reg: 'us', name: 'Yemen' },
  { value: 'ZM', region: 'us/en', reg: 'us', name: 'Zambia' },
  { value: 'ZW', region: 'us/en', reg: 'us', name: 'Zimbabwe' },
];

export default CountriesList;
